(() => {
  'use strict';
  function refreshReturn(form) {
    const url = new URL(window.location.href);
    ['preview_theme_id', 'section_id', 'sections'].forEach(key => url.searchParams.delete(key));
    const packed = url.searchParams.get('leshems_selection');
    url.searchParams.delete('leshems_selection');
    const root = document.querySelector('[data-leshems-native-root]');
    let supported = [];
    try { supported = JSON.parse(root?.dataset.nativeSupportedFilters || '[]'); } catch {}
    const repeated = {};
    try {
      const previous = JSON.parse(packed || 'null');
      const entries = previous && !Array.isArray(previous) && typeof previous === 'object' ? Object.entries(previous) : [];
      if (Array.isArray(supported) && packed?.length <= 20000 && entries.length <= 25 && entries.reduce((n, [, values]) => n + (Array.isArray(values) ? values.length : 101), 0) <= 100 && entries.every(([name, values]) => name.startsWith('filter.') && supported.includes(name) && Array.isArray(values) && values.length > 1 && values.every(value => typeof value === 'string' && value.length > 0 && value.length <= 512))) {
        entries.forEach(([name, values]) => { repeated[name] = values; });
      }
    } catch {}
    if (Array.isArray(supported)) {
      for (const name of new Set(url.searchParams.keys())) {
        const values = url.searchParams.getAll(name);
        if (name.startsWith('filter.') && supported.includes(name) && values.length > 1) repeated[name] = values;
      }
    }
    if (Object.keys(repeated).length) url.searchParams.set('leshems_selection', JSON.stringify(repeated));
    const input = form.querySelector('input[name="return_to"]');
    if (input) input.value = url.pathname + url.search + url.hash;
  }
  function isLanguageForm(form) {
    if (!form?.matches('form') || !form.querySelector('[name="language_code"]')) return false;
    try {
      const action = new URL(form.action, window.location.href);
      return action.origin === window.location.origin && action.pathname.endsWith('/localization');
    } catch { return false; }
  }
  document.querySelectorAll('form[action]').forEach(form => { if (isLanguageForm(form)) refreshReturn(form); });
  document.addEventListener('submit', event => {
    if (isLanguageForm(event.target)) refreshReturn(event.target);
  }, true);
})();
